module.exports = __webpack_public_path__ + "img/sidebar_dfbpokal_202627.73022660.png";